import React from 'react';
import ReactToolTip from 'react-tooltip';
import {STYLE_RECORDING_INFO_ITEM} from "../Recording";
import {getFormattedDuration} from "../../../utils/date";

const TOOLTIP_RUNTIME_ID = "runtimeTip";

/**
 * A component that displays duration
 * information on the recording form
 */
const Runtime = ({runtime}) => (
    <div style={STYLE_RECORDING_INFO_ITEM}>
        <div data-tip data-for={TOOLTIP_RUNTIME_ID}>
            <i className="fas fa-clock"/> {getFormattedDuration(runtime)}
        </div>
        <ReactToolTip id={TOOLTIP_RUNTIME_ID}>
            <span>The duration of the uploaded recording.</span>
        </ReactToolTip>
    </div>
);


export default Runtime;



// WEBPACK FOOTER //
// ./src/components/recording/information/Runtime.jsx